import {forwardRef, memo} from 'react'
import styles from './RailsPartial.module.css'
import {clsx} from 'clsx'

export type SafeRailsHTML = string & {__safeRailsHTMLBrand: never}

export type RailsPartialProps = Omit<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  'ref'
> & {
  html?: SafeRailsHTML
}

const RailsPartialUnmemoized = forwardRef<HTMLDivElement, RailsPartialProps>(({html, className, ...props}, ref) => {
  if (!html) return null

  return (
    <div
      ref={ref}
      className={clsx(styles['d-contents'], className)}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{__html: html}}
      {...props}
    />
  )
})
RailsPartialUnmemoized.displayName = 'RailsPartial'

// Prevent re-renders if the HTML content hasn't changed
const RailsPartial = memo(RailsPartialUnmemoized, (prevProps, nextProps) => {
  return prevProps.html === nextProps.html
})

export {RailsPartial}

try{ RailsPartial.displayName ||= 'RailsPartial' } catch {}